// Year End Period Reducer
import {
  GET_YEAR_END_PERIOD_LIST,
  GET_YEAR_END_PERIOD_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_LIST_FAILURE,
  GET_YEAR_END_PERIOD_DETAILS,
  GET_YEAR_END_PERIOD_DETAILS_SUCCESS,
  GET_YEAR_END_PERIOD_DETAILS_FAILURE,
  UPDATE_YEAR_END_PERIOD_DETAILS,
  UPDATE_YEAR_END_PERIOD_DETAILS_SUCCESS,
  UPDATE_YEAR_END_PERIOD_DETAILS_FAILURE,
  CREATE_YEAR_END_PERIOD,
  CREATE_YEAR_END_PERIOD_SUCCESS,
  CREATE_YEAR_END_PERIOD_FAILURE,
  DELETE_YEAR_END_PERIOD,
  DELETE_YEAR_END_PERIOD_SUCCESS,
  DELETE_YEAR_END_PERIOD_FAILURE,
  GET_YEAR_END_PERIOD_INVOICE_LIST,
  GET_YEAR_END_PERIOD_INVOICE_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_INVOICE_LIST_FAILURE,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_FAILURE,
  GET_YEAR_END_PERIOD_PURCHASE_LIST,
  GET_YEAR_END_PERIOD_PURCHASE_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_PURCHASE_LIST_FAILURE,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_FAILURE,
} from "./actionType";

const initialState = {
  yearEndPeriodList: [],
  yearEndPeriodListLoading: false,
  yearEndPeriodDetails: [],
  yearEndPeriodDetailsLoading: false,
  updateYearEndPeriodDetailsSuccess: [],
  updateYearEndPeriodDetailsLoading: false,
  createYearEndPeriodSuccess: [],
  createYearEndPeriodLoading: false,
  deleteYearEndPeriodSuccess: [],
  deleteYearEndPeriodLoading: false,
  yearEndPeriodInvoiceList: [],
  yearEndPeriodInvoiceListLoading: false,
  yearEndPeriodInvoiceItemsList: [],
  yearEndPeriodInvoiceItemsListLoading: false,
  yearEndPeriodPurchaseList: [],
  yearEndPeriodPurchaseListLoading: false,
  yearEndPeriodPurchaseItemsList: [],
  yearEndPeriodPurchaseItemsListLoading: false,
};

const YearEndPeriod = (state = initialState, action) => {
  switch (action.type) {
    case GET_YEAR_END_PERIOD_LIST:
      return {
        ...state,
        yearEndPeriodListLoading: true,
      };
    case GET_YEAR_END_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        yearEndPeriodList: action.payload,
        yearEndPeriodListLoading: false,
      };
    case GET_YEAR_END_PERIOD_LIST_FAILURE:
      return {
        ...state,
        yearEndPeriodListLoading: false,
      };
    case GET_YEAR_END_PERIOD_DETAILS:
      return {
        ...state,
        yearEndPeriodDetailsLoading: true,
      };
    case GET_YEAR_END_PERIOD_DETAILS_SUCCESS:
      return {
        ...state,
        yearEndPeriodDetails: action.payload,
        yearEndPeriodDetailsLoading: false,
      };
    case GET_YEAR_END_PERIOD_DETAILS_FAILURE:
      return {
        ...state,
        yearEndPeriodDetailsLoading: false,
      };
    case UPDATE_YEAR_END_PERIOD_DETAILS:
      return {
        ...state,
        updateYearEndPeriodDetailsLoading: true,
      };
    case UPDATE_YEAR_END_PERIOD_DETAILS_SUCCESS:
      return {
        ...state,
        updateYearEndPeriodDetailsSuccess: action.payload,
        updateYearEndPeriodDetailsLoading: false,
      };
    case UPDATE_YEAR_END_PERIOD_DETAILS_FAILURE:
      return {
        ...state,
        updateYearEndPeriodDetailsLoading: false,
      };
    case CREATE_YEAR_END_PERIOD:
      return {
        ...state,
        createYearEndPeriodLoading: true,
      };
    case CREATE_YEAR_END_PERIOD_SUCCESS:
      return {
        ...state,
        createYearEndPeriodSuccess: action.payload,
        createYearEndPeriodLoading: false,
      };
    case CREATE_YEAR_END_PERIOD_FAILURE:
      return {
        ...state,
        createYearEndPeriodLoading: false,
      };
    case DELETE_YEAR_END_PERIOD:
      return {
        ...state,
        deleteYearEndPeriodLoading: true,
      };
    case DELETE_YEAR_END_PERIOD_SUCCESS:
      return {
        ...state,
        deleteYearEndPeriodSuccess: action.payload,
        deleteYearEndPeriodLoading: false,
      };
    case DELETE_YEAR_END_PERIOD_FAILURE:
      return {
        ...state,
        deleteYearEndPeriodLoading: false,
      };
    case GET_YEAR_END_PERIOD_INVOICE_LIST:
      return {
        ...state,
        yearEndPeriodInvoiceListLoading: true,
      };
    case GET_YEAR_END_PERIOD_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        yearEndPeriodInvoiceList: action.payload,
        yearEndPeriodInvoiceListLoading: false,
      };
    case GET_YEAR_END_PERIOD_INVOICE_LIST_FAILURE:
      return {
        ...state,
        yearEndPeriodInvoiceListLoading: false,
      };
    case GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST:
      return {
        ...state,
        yearEndPeriodInvoiceItemsListLoading: true,
      };
    case GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        yearEndPeriodInvoiceItemsList: action.payload,
        yearEndPeriodInvoiceItemsListLoading: false,
      };
    case GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_FAILURE:
      return {
        ...state,
        yearEndPeriodInvoiceItemsListLoading: false,
      };
    case GET_YEAR_END_PERIOD_PURCHASE_LIST:
      return {
        ...state,
        yearEndPeriodPurchaseListLoading: true,
      };
    case GET_YEAR_END_PERIOD_PURCHASE_LIST_SUCCESS:
      return {
        ...state,
        yearEndPeriodPurchaseList: action.payload,
        yearEndPeriodPurchaseListLoading: false,
      };
    case GET_YEAR_END_PERIOD_PURCHASE_LIST_FAILURE:
      return {
        ...state,
        yearEndPeriodPurchaseListLoading: false,
      };
    case GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST:
      return {
        ...state,
        yearEndPeriodPurchaseItemsListLoading: true,
      };
    case GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        yearEndPeriodPurchaseItemsList: action.payload,
        yearEndPeriodPurchaseItemsListLoading: false,
      };
    case GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_FAILURE:
      return {
        ...state,
        yearEndPeriodPurchaseItemsListLoading: false,
      };

    default:
      return state;
  }
};

export default YearEndPeriod;
